import styled from '@emotion/styled'

import {
  Alert,
  MasterDetail,
  PerformanceChart,
  ProjectionChart,
  Section,
  Space,
  ValidationMessage
} from '../../../../../components/core-v2'
import { CollateralAlert } from '../../../util/Alerts'
import { WizardButtons } from '../../00-builder/wizard-buttons'
import { PortfolioEditor } from '../editor'
import { PortfolioStepActions, PortfolioStepState } from '../state/portfolio-slice'

export type PortfolioStepStatelessProps = {
  actions: PortfolioStepActions
  onMoveBack: () => void
  onSaveAndContinue: () => void
  state: PortfolioStepState
}

const StyledView = styled.div`
  height: calc(100vh - 184px);
  overflow-y: auto;
`

export const PortfolioStepStateless = ({
  actions,
  onMoveBack,
  onSaveAndContinue,
  state
}: PortfolioStepStatelessProps) => {
  if (state.isDataError) {
    return (
      <Space mt={4}>
        <Alert title="Error" type="error">
          {state.dataErrorText}
        </Alert>
      </Space>
    )
  }

  return (
    <MasterDetail
      detailBackground="transparent"
      detailChildren={
        <StyledView>
          <Section my={6} type="primary">
            {state.model?.isChosen &&
              state.model.performanceMetrics &&
              (state.portfolioType === 'ModelPortfolio' ||
                state.portfolioType === 'FundOfFunds') && (
                <>
                  {state.model.performanceMetrics && (
                    <PerformanceChart
                      isError={false}
                      isLoading={false}
                      metrics={state.model.performanceMetrics}
                      title="Historical performance (portfolio)"
                    />
                  )}

                  {state.model.projection && (
                    <ProjectionChart
                      isError={false}
                      isLoading={false}
                      metrics={state.model.projection}
                      title="Projections (portfolio)"
                    />
                  )}
                </>
              )}
            {state.selfSelect?.isChosenAsset &&
              state.selfSelect.performanceMetrics &&
              state.portfolioType === 'SelfSelect' && (
                <>
                  {state.selfSelect.performanceMetrics && (
                    <PerformanceChart
                      isError={false}
                      isLoading={false}
                      metrics={state.selfSelect.performanceMetrics}
                      title="Historical performance (portfolio)"
                    />
                  )}

                  {state.selfSelect.projection && (
                    <ProjectionChart
                      isError={false}
                      isLoading={false}
                      metrics={state.selfSelect.projection}
                      title="Projections (portfolio)"
                    />
                  )}
                </>
              )}
          </Section>
        </StyledView>
      }
      masterBackground="white98"
      masterChildren={
        <StyledView>
          <Section mt={6} type="primary">
            <PortfolioEditor actions={actions} state={state} />
          </Section>
          <Space>
            <ValidationMessage key="portfolio_errors" errors={state.errors} />
            <ValidationMessage
              key="builder_errors"
              errors={state.builderErrors}
              excludeFieldNames={['collateral']}
            />
          </Space>
          <CollateralAlert />
          <WizardButtons
            canMoveBack
            canMoveNext={state.canProceed}
            onMoveBack={onMoveBack}
            onMoveNext={onSaveAndContinue}
          />
        </StyledView>
      }
      width="half"
    />
  )
}
